import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../../utils/api-client';

export interface OntologyTreeItem {
    accession: string;
    elementId: string;
    name: string;
    children: OntologyTreeItem[];
}

export interface OntologyElement {
    name: string;
    content?: string;
    tree: {
        roots: OntologyTreeItem[];
    };
}

export const useOntologyElementQuery = (props: {
    accession: string;
    documentId?: number;
    versionId?: number | null;
    nodeId?: string;
    isExploreMode: boolean;
}) => {
    const path = props.isExploreMode
        ? `documents-revisions-service/api/ontologies/elements/${props.nodeId}?document-id=${props.documentId}&global-version=${props.versionId}`
        : `documents-revisions-service/api/ontologies/elements/${props.nodeId}?accession=${props.accession}`;

    return useQuery({
        queryKey: [
            'getOntologyElement',
            props.accession,
            props.nodeId,
            props.documentId,
            props.versionId
        ],
        queryFn: () => apiClient.get<OntologyElement>({path}),
        enabled: !!props.nodeId
    });
};
